<template id="">
    <fieldset>
        <div class="row">
            <div class="col-md-6">
                <div class="form-group">
                    <label class="" :for="passwordId">Password</label>
                    <password-input-component
                        v-model="password"
                        :show="showPassword"
                        v-on:input="(value) => onChange(value)"
                        v-on:show="() => showPassword = true"
                        v-on:hide="() => showPassword = false"
                        :config="{required: required, id: passwordId}"
                        ></password-input-component>
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    <label class="" :for="confirmPasswordId">Confirm Password</label>
                    <input :type="showPassword ? 'text' : 'password'"
                        name="confirmPassword"
                        :id="confirmPasswordId"
                        class="form-control form-control-lg"
                        autocomplete="new-password"
                        value=""
                        :required="required">
                    <small class="invalid-feedback">Passwords do not match</small>
                </div>
            </div>
        </div>
    </fieldset>
</template>
<script charset="utf-8">
import PasswordInputComponent from './PasswordInputComponent.vue';

export default {
    data() {
        return {
            showPassword: false,
            password: '',
            confirm: '',
            dirty: false,
            isMatch: true,

        }
    },

    props: ['config', 'timestamp'],

    components: {
        PasswordInputComponent,
    },

    computed: {
        required(){
            return _.get(this.config, 'required', false);
        },

        randomKey() {
            return Math.random().toString(36).substring(7);
        },

        passwordId() {
            return `password-${this.randomKey}`;
        },

        confirmPasswordId() {
            return `confirmPassword-${this.randomKey}`;
        },
    },

    watch: {
        value(newVal) {
            if (!newVal) {
                this.$emit('input', null);
            }
        },
    },

    methods: {
        onChange(value) {
            this.isMatch = value == this.confirm;
            this.$emit('error', { password: this.isMatch ? null : 'Passwords do not match' });
            return this.$emit('input', value);
        },

        checkConfirm(value) {
            this.isMatch = value == this.value;
            this.$emit('error', { password: this.isMatch ? null : 'Passwords do not match' });
        },

        toggleShowPassword() {
            this.showPassword = !this.showPassword;
        },

        generatePassword() {
            let length = 10;
            let charset = "abcdefghijklmnopqrstuvwxyz";
            let uppercaseCharset = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
            let specialCharset = "~!@#$%^&*_-=+";
            let numbersCharset = "0123456789";

            let password = _.chain([])
                .concat(this.pickChars(charset, 6))
                .concat(this.pickChars(uppercaseCharset, 3))
                .concat(this.pickChars(numbersCharset, 1))
                .shuffle()
                .join('')
                .value();

            this.confirm = password;
            this.showPassword = true;
            this.$emit('input', password);
            this.$emit('error', { password: null });
        },

        pickChars(charset, number) {
            let chars = [];
            for (var i = 0, n = charset.length; i < number; ++i) {
                chars.push(charset.charAt(Math.floor(Math.random() * n)));
            }

            return chars;
        },
    }
}
</script>
